import { ArrowUpRight } from "lucide-react";
import { PORTFOLIO } from "@/lib/data";

export default function Portfolio() {
  return (
    <section id="portfolio" data-testid="portfolio-section" className="py-24 lg:py-32 bg-[#FDFBFA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="eyebrow">Selected Work</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 text-[#041047] tracking-tight leading-[1.1]">
              Real campaigns. <em className="italic font-medium">Real results.</em>
            </h2>
          </div>
          <a href="#contact" data-testid="portfolio-cta" className="btn-secondary">
            Request Case Studies
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {PORTFOLIO.map((p, i) => (
            <div
              key={p.title}
              data-testid={`portfolio-item-${i}`}
              className="group cursor-pointer"
            >
              <div className="overflow-hidden border border-[#041047]/10 bg-white">
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={p.img}
                    alt={p.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-6 md:p-8 flex items-start justify-between gap-4">
                  <div>
                    <div className="text-xs uppercase tracking-[0.18em] text-[#475569] mb-2">
                      {p.category}
                    </div>
                    <h3 className="font-display text-2xl text-[#041047] mb-1">{p.title}</h3>
                    <p className="text-[#D4AF37] text-sm font-semibold">{p.stat}</p>
                  </div>
                  <div className="w-10 h-10 border border-[#041047]/15 flex items-center justify-center group-hover:bg-[#041047] group-hover:border-[#041047] transition-colors flex-shrink-0">
                    <ArrowUpRight className="w-4 h-4 text-[#041047] group-hover:text-white transition-colors" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
